import React, { useState, useEffect } from 'react';

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    padding: '16px 0',
    transition: 'all 0.3s ease',
  },
  navScrolled: {
    background: 'rgba(5,8,21,0.9)',
    backdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    padding: '12px 0',
  },
  inner: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    maxWidth: 1100, margin: '0 auto', padding: '0 24px',
  },
  logo: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontFamily: 'Sora, sans-serif', fontWeight: 700, fontSize: 20,
    color: '#f0f4ff',
  },
  logoIcon: {
    width: 32, height: 32,
    background: 'linear-gradient(135deg, #6c63ff, #3b82f6)',
    borderRadius: 8,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, color: '#fff',
  },
  links: {
    display: 'flex', gap: 32, alignItems: 'center',
    listStyle: 'none',
  },
  link: {
    fontFamily: 'DM Sans, sans-serif', fontSize: 14, fontWeight: 400,
    color: '#8892b0', cursor: 'pointer', transition: 'color 0.2s',
  },
  actions: { display: 'flex', gap: 12, alignItems: 'center' },
  btnLogin: {
    background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
    color: '#f0f4ff', padding: '8px 20px', borderRadius: 8,
    fontSize: 13, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    cursor: 'pointer', transition: 'all 0.2s',
  },
  btnDemo: {
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    border: 'none', color: '#fff',
    padding: '8px 20px', borderRadius: 8,
    fontSize: 13, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.2s',
    boxShadow: '0 4px 15px rgba(108,99,255,0.35)',
  },
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : {}) }}>
      <div style={styles.inner}>
        <div style={styles.logo}>
          {/* <img src="/assets/logo.png" alt="ArchiVex" style={{ height: 32 }} /> */}
          <span>Archi<span style={{ color: '#6c63ff' }}>Vex</span></span>
        </div>

        <ul style={styles.links}>
          {[['beneficios', 'Beneficios'], ['precios', 'Precios'], ['contacto', 'Contacto']].map(([id, label]) => (
            <li key={id}>
              <span
                style={styles.link}
                onClick={() => scrollTo(id)}
                onMouseEnter={e => e.target.style.color = '#f0f4ff'}
                onMouseLeave={e => e.target.style.color = '#8892b0'}
              >{label}</span>
            </li>
          ))}
        </ul>

        <div style={styles.actions}>
          <button style={styles.btnLogin}
            onClick={() => window.location.href = 'https://app.archivex.mx'}
            onMouseEnter={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
            onMouseLeave={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
          >Iniciar Sesión</button>
          <button style={styles.btnDemo}
            onClick={() => scrollTo('contacto')}
            onMouseEnter={e => e.target.style.transform = 'translateY(-1px)'}
            onMouseLeave={e => e.target.style.transform = 'translateY(0)'}
          >Solicitar Demo</button>
        </div>
      </div>
    </nav>
  );
}
